"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlePipe = void 0;
const pipe_1 = require("./pipe");
const handle_1 = require("./handle");
exports.handlePipe = (...fns) => (args) => handle_1.handle(pipe_1.pipe(...fns)(args));
exports.default = exports.handlePipe;
